import { jsx as _jsx } from "react/jsx-runtime";
import { FlexBox } from '@dixa/lib-shared-habla';
import { ButtonToggle } from './components/buttonToggle';
/** Renders the footer section of the bulletin board editor. */
export function Footer({ canShowPublished, viewMode, setViewMode, }) {
    if (!canShowPublished) {
        return _jsx("div", {});
    }
    return (_jsx(FlexBox, Object.assign({ justifyContent: "center", margin: "32px" }, { children: _jsx(ButtonToggle, { onChange: setViewMode, value: viewMode }) })));
}
